import { useEffect, useState } from "react"
import Config from "../Config";

interface iGaleria{
    imagenes: any,
}
export default function Galeria(props: iGaleria){
    const [imagenActual, setImagenActual] = useState(null);
    const [posicion, setPosicion] = useState(0);

    useEffect(() => {
        const imgs = props?.imagenes;
        console.log("imgs:",imgs)
        if ( imgs?.length > 0){
            console.log(imgs[0].pathRel);
            setImagenActual(imgs[0].pathRel);
        }
        
    },[props]);

    const proximo = () => {
        let prox = posicion +1;
        if (prox >= props?.imagenes?.length){
            prox = 0;
        }
        console.log("proximo:", prox);

        setPosicion(prox);
        setImagenActual(props.imagenes[prox]?.pathRel);
    }

    const anterior = () => {
        let prox = posicion -1;
        if (prox < 0){
            prox = props?.imagenes?.length-1;
        }
        console.log("anterior:", prox);

        setPosicion(prox);
        setImagenActual(props.imagenes[prox]?.pathRel);
    }

    return  <div style={{width: 250, height: 250, }}>
                <div style={{height: 200}}>
                    <img src={imagenActual || Config.SinImagen} style={{width: 200, height: 200}} />
                </div>
                {
                    (props.imagenes?.length > 1)?
                        <div style={{height: 50,}}>
                            <button 
                                style={{width: '40%', height: 45, backgroundColor: 'blue', color: 'white', fontSize: '150%'}}
                                onClick={() => {
                                anterior();
                            }}>{'<--'}</button>

                            <button 
                                style={{width: '40%', height: 45, backgroundColor: 'blue', color: 'white', fontSize: '150%'}}
                                onClick={() => {
                                proximo();
                            }}>{'-->'}</button>
                        </div>   
                    :null
                }
            </div>
}